import { Routes, Route} from 'react-router-dom';
import App from '../App';
import Orders from '../components/Orders';

function Routing() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/orders" element={<Orders />} />
      </Routes>
    </div>
  );
}

export default Routing;
